<script setup lang="ts">
import { computed, ref, watch } from "vue";

const emit = defineEmits(["closed"]);
interface Props {
  message: string | null;
  details?: string | null;
  hideClose?: boolean;
  messageType: "confirm" | "critical" | "informative" | "caution";
}

const props = defineProps<Props>();
const internalMessage = ref(props.message);
const showDetails = ref(false);

watch(
  () => props.message,
  (newValue) => {
    internalMessage.value = newValue;
  }
);

const notificationClass = computed(() => {
  switch (props.messageType) {
    case 'confirm':
      return 'bg-confirm-surface';
    case 'critical':
      return 'bg-critical-surface';
    case 'informative':
      return 'bg-informative-surface';
    case 'caution':
      return 'bg-caution-surface';
    default:
      return 'bg-informative-surface';
  }
});

const close = () => {
  // internalMessage.value = null;
  emit("closed");
};
</script>
<template>
  <div :class="notificationClass" v-if="internalMessage" class="notification-wrapper text-lg   font-semibold p-4 shadow-md">
    <button v-show="!hideClose" @click="close" class="absolute right-2 top-2">
      <i class="fas fa-times"></i>
    </button>
    {{ internalMessage }}
    <div class="mt-2">
      <div class="text-sm" v-if="props.details && showDetails">{{ props.details }}</div>
      <a class="text-sm" v-if="props.details" @click="showDetails = !showDetails">{{
        showDetails ? "Hide Details" : "Show Details"
      }}</a>
    </div>
  </div>
</template>

<style scoped>
.notification-wrapper {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

/* Add padding to top nav to prevent overlap */
:deep(.bg-confirm-surface) {
  border-left: 4px solid var(--color-confirm-standard);
}

:deep(.bg-critical-surface) {
  border-left: 4px solid var(--color-critical-standard);
}

:deep(.bg-informative-surface) {
  border-left: 4px solid var(--color-informative-standard);
}

:deep(.bg-caution-surface) {
  border-left: 4px solid var(--color-caution-standard);
}
</style>
